var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoSystemTemplate = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.19 20.11",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26446",
    "data-name": "Group 26446"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_system_2890032",
    "data-name": "noun system 2890032"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46813",
    "data-name": "Path 46813",
    d: "M968.28,506v-1a1.07,1.07,0,0,0,.85-1,1.1,1.1,0,0,0-1.06-1.14,1.09,1.09,0,0,0-1.14,1.05,1.12,1.12,0,0,0,.84,1.12v1a.94.94,0,0,1-1,.93h-2.2a1.69,1.69,0,0,0-1.18-.74v-3.45a1.07,1.07,0,0,0,.84-1,1.1,1.1,0,1,0-1.36,1v3.45a1.69,1.69,0,0,0-1.18.74h-2.18a.94.94,0,0,1-1-.92h0v-1a1.07,1.07,0,0,0,.85-1,1.1,1.1,0,0,0-2.2-.09,1.12,1.12,0,0,0,.84,1.12v1a1.47,1.47,0,0,0,1.49,1.42h2a1.14,1.14,0,0,0,0,.37,1.59,1.59,0,0,0,.6,1.23v2.24a.93.93,0,0,1-1,.93H960a1.1,1.1,0,0,0-2.16.4,1.11,1.11,0,0,0,2.16.1h1.07a1.48,1.48,0,0,0,1.49-1.43v-2a1.84,1.84,0,0,0,.57.09,1.9,1.9,0,0,0,.58-.09v2a1.45,1.45,0,0,0,1.48,1.42h1.07a1.06,1.06,0,1,0,0-.49h-1.07a.94.94,0,0,1-1-.92h0V509a1.58,1.58,0,0,0,.6-1.24,1.42,1.42,0,0,0,0-.36h2A1.45,1.45,0,0,0,968.28,506Zm-.85-2a.6.6,0,0,1,1.19-.05.6.6,0,0,1-.57.62h0a.6.6,0,0,1-.6-.57Zm-9.7,0a.58.58,0,0,1,.56-.61.59.59,0,0,1,.62.56.6.6,0,0,1-.57.62h0a.59.59,0,0,1-.59-.57Zm5.44,4.95a1.13,1.13,0,1,1,.1-2.26,1.13,1.13,0,0,1,1.08,1.13,1.14,1.14,0,0,1-1.17,1.12h0Z",
    transform: "translate(-951.14 -493.67)",
    fill: "#999",
    stroke: "#999",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26445",
    "data-name": "Group 26445",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_11660",
    "data-name": "Rectangle 11660",
    d: "M957.64,493.67h10.5a1,1,0,0,1,1,1v4.5a.5.5,0,0,1-.5.5h-11a.5.5,0,0,1-.5-.5v-5A.5.5,0,0,1,957.64,493.67Z",
    transform: "translate(-951.14 -493.67)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_11661",
    "data-name": "Rectangle 11661",
    d: "M952.14,493.67h3.5a.5.5,0,0,1,.5.5v19a.5.5,0,0,1-.5.5h-3.5a1,1,0,0,1-1-1v-18A1,1,0,0,1,952.14,493.67Z",
    transform: "translate(-951.14 -493.67)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoSystemTemplate);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_systemTemplate.296fdca7595933d22a66abd3d45e129e.svg";